import React, { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import { Layout } from './components'
import { ElectroluxLayout } from './components/Electrolux/Layout/Index'
import { ProtectedPage } from './components/ProtectedPage'

import {
  ApplicationManagementPage,
  ConsumerPortalStatusPage,
  DealerGroupPage,
  DealerPortalPage,
  DispatchMessage,
  DispatchStatusPage,
  HomePage,
  LoginPage,
  ResetPassword,
  SurveyMonkeyMasterPage,
  UserManagementPage,
  UserRoleManagementPage,
} from './pages'
import { ElectroluxPortal } from './pages/Agent/Electrolux/Portal'
import { SearchResult } from './pages/Agent/Electrolux/SearchResult'
import { AgentUserManagementPage } from './pages/Agent/Users/AgentUserManagementPage'
import { ScheduleService } from './pages/Bounce/ScheduleService'
import { ServiceSuccess } from './pages/Bounce/ServiceSuccess'
import { ServicerPortalPage } from './pages/FlightTrackerServicer'
import { SolicitationPurchaseIncompleteReport } from './reports/SolicitationPurchaseIncomplete'
import { SaleIntegrityPage } from './pages/SaleIntegrity'
// @ts-ignore: side-effect import for toast styles without CSS module declarations
import 'react-toastify/dist/ReactToastify.css'
import { ModulePage } from './pages/Modules'
import { DealerType } from './pages/DealerType'
import { ClientPage } from './pages/Clients'

const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  if (match) return match[2]
  return null
}

export const App = () => {
  useEffect(() => {
    const accessToken = getCookie('access_token')
    const loggedIn = getCookie('logged_in')

    const isPasswordRoute = window.location.pathname.startsWith('/password')

    if (!isPasswordRoute && window.location.pathname !== '/login') {
      if (!accessToken || loggedIn !== 'true') {
        window.location.href = '/login'
      }
    }
  }, [])

  return (
    <React.Fragment>
      <ToastContainer />
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route element={<ProtectedPage />}>
            <Route index element={<HomePage />} />
          </Route>
          <Route path='agent' element={<ProtectedPage allowedUserRoleList={['Admin']} />}>
            <Route path='users' element={<AgentUserManagementPage />} />
          </Route>
          <Route
            path='reports'
            element={
              <ProtectedPage
                allowedUserRoleList={['Admin']}
                allowedApplicationList={['Intranet']}
              />
            }
          >
            <Route
              path='incompletesolicitations'
              element={<SolicitationPurchaseIncompleteReport />}
            />
          </Route>
          <Route
            path='admin'
            element={
              <ProtectedPage
                allowedUserRoleList={['Admin']}
                allowedApplicationList={['Intranet']}
              />
            }
          >
            <Route path='dispatchmessage' element={<DispatchMessage />} />
            <Route path='surveymonkeymaster' element={<SurveyMonkeyMasterPage />} />
            <Route path='flighttrackerconsumer' element={<ConsumerPortalStatusPage />} />
            <Route path='users' element={<UserManagementPage />} />
            <Route path='roles' element={<UserRoleManagementPage />} />
            <Route path='applications' element={<ApplicationManagementPage />} />
            <Route path='surveymonkeymaster' element={<SurveyMonkeyMasterPage />} />
            <Route path='dealergroups' element={<DealerGroupPage />} />
            <Route path='modules' element={<ModulePage />} />
            <Route path='dealerType' element={<DealerType />} />
            <Route path='clients' element={<ClientPage />} />
            <Route path='dealerportal' element={<DealerPortalPage />} />
            <Route path='servicerportal' element={<ServicerPortalPage />} />
            <Route path='statusdispatch' element={<DispatchStatusPage />} />
            <Route path='saleIntegrity' element={<SaleIntegrityPage />} />
          </Route>
        </Route>
        <Route
          path='electrolux'
          element={<ProtectedPage allowedApplicationList={['Electrolux', 'Intranet']} />}
        >
          <Route element={<ElectroluxLayout />}>
            <Route path='home' element={<ElectroluxPortal />} />
            <Route path='search-results' element={<SearchResult />} />
          </Route>
        </Route>
        <Route path='login' element={<LoginPage />} />
        <Route path='password/reset/:token' element={<ResetPassword />} />
        <Route path='bounce/scheduleService' element={<ScheduleService />} />
        <Route path='bounce/scheduleService/success' element={<ServiceSuccess />} />
        <Route path='*' element={<LoginPage />} />
      </Routes>
    </React.Fragment>
  )
}
